import { QuickfireEndRound } from "quickfire/commands/quickfire-end-round-command";
import QuickfireFreeGamesComponent from "quickfire/components/quickfire-free-games-component";
import { SignalBinding } from "signals";
import WinCycle from "slotworks/state-machine/standard/super-states/win-cycle";

export default class QuickfireWinCycle extends WinCycle {

    private discardBinding: SignalBinding;

    public onEnter() {
        this.discardBinding = QuickfireFreeGamesComponent.onDiscard.addOnce(() => this.collapse());

        super.onEnter();
    }

    public onExit() {
        this.discardBinding.detach();
        this.discardBinding = null;

        super.onExit();
    }

    protected rollupComplete() {
        QuickfireEndRound();
    }
}
